import React, { FunctionComponent, useMemo } from "react";
import { styled, formPadding } from "@iventis/styles";
import { ScheduleConfigEventBlockType } from "@iventis/domain-model/model/scheduleConfigEventBlockType";
import { ScheduleConfigVenueLocationType } from "@iventis/domain-model/model/scheduleConfigVenueLocationType";
import { DataField } from "@iventis/domain-model/model/dataField";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

import { EditEventBlockType } from "./edit-event-block-type";
import { getEventBlockTitle, getSummaryDataFieldValues, orderEventBlockConfigs } from "./edit-event-block-type-helpers";

interface EditEventBlockTypesProps {
    eventBlockTypes: ScheduleConfigEventBlockType[];
    venueTypes: ScheduleConfigVenueLocationType[];
    dataFields: DataField[];
    onValueChange: (config: ScheduleConfigEventBlockType[]) => void;
    onDataFieldsChange: (dataFields: DataField[]) => void;
}

export const EditEventBlockTypesComponent: FunctionComponent<EditEventBlockTypesProps> = ({ eventBlockTypes, venueTypes, dataFields, onValueChange, onDataFieldsChange }) => {
    const translate = useIventisTranslate();

    // Memos
    const orderedConfigs = useMemo(() => (eventBlockTypes ? orderEventBlockConfigs(eventBlockTypes) : []), [eventBlockTypes]);

    // Value change handlers
    const onChange = (configChange: ScheduleConfigEventBlockType) => {
        onValueChange([...eventBlockTypes.filter(({ id }) => id !== configChange.id), configChange]);
    };

    return (
        <EditScheduleConfigContainer>
            {orderedConfigs.map((eventBlockType, index) => (
                <EditEventBlockType
                    key={eventBlockType.id}
                    eventBlockType={eventBlockType}
                    eventBlockTypes={orderedConfigs}
                    dataFields={dataFields}
                    venueTypes={venueTypes}
                    onValueChange={onChange}
                    title={getEventBlockTitle(index, translate)}
                    onDataFieldsChange={onDataFieldsChange}
                    showCustomerIdentifier={eventBlockType.calendarLevel === 2}
                    requiredSystemDataFields={eventBlockType.calendarLevel === 1}
                    childEventBlockDataFields={getSummaryDataFieldValues(eventBlockType.calendarLevel, eventBlockTypes, dataFields)}
                    editName={false}
                />
            ))}
        </EditScheduleConfigContainer>
    );
};

export const EditScheduleConfigContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${formPadding};
`;
